import PreferenceTypes from '@/store/preference-types';

const segmentsMixins = {
    data() {
        return {
            hasServerError: false,
        };
    },
    computed: {
        preferences() {
            return this.getUserPreference(PreferenceTypes.modules, 'dashboard/segments');
        },
        activeSegments() {
            if (this.preferences) {
                return this.preferences.activeSegments.map(id => this.preferences.segments[id]);
            }
            return [];
        },
    },
};

export default segmentsMixins;
